import {BBModel} from "../../bb_model";
import {Set} from "./set";
import {SlotCollection} from "../slot_collection";
import {BookingSet} from "./booking_set";

class SlotSet extends Set {

    constructor(company) {
        super(BBModel.Admin.Slot, company);
        const bookingSet = company.bookings;
        bookingSet.addListener(this.handleBookingPush, this);
    }

    handleBookingPush(oldPush) {
        const push = Object.assign({}, oldPush);
        if (push.action == 'update') {
            const booking = push.object;
            if (booking.$has('slot')) {
                push.url = booking.$link('slot').href;
                push.model = 'slot';
                push.group = 'slots';
                push.type = 'slot';
                this.handlePush(push);
            }
        }
    }

    getSlot(company, id) {
        return new Promise((resolve, reject) => {
            return company.$get('slots')
                .then(slots => slots.$get('slot', {id}))
                .then((slot) => {
                    const url = slot.$link('self').href;
                    if (this.set[url]) {
                        resolve(this.set[url]);
                    } else {
                        const model = new BBModel.Admin.Slot(slot);
                        this.addItem(model);
                        resolve(model);
                    }
                }, reject);
        });
    }

    fetchRequired(push) {
        if (push.properties) {
            const pushProperties = push.properties;
            pushProperties.slot_id = push.id
            pushProperties.start_time = moment(pushProperties.start_time);
            pushProperties.datetime = pushProperties.start_time;
            pushProperties.end_time = moment(pushProperties.end_time);
            return Object.values(this.collections).some((collection) => {
                return collection.checkParams(pushProperties);
            });
        } else {
            return true;
        }
    }

    $query(company, params) {
        return SlotCollection.$query(this, company, params);
    }

    static $query(company, params) {
        return company.slots.$query(company, params);
    }

}

SlotSet.group = 'slots';
SlotSet.model = 'slot';
SlotSet.all = {};

export {
    SlotSet
}


